// Helpers de présentation partagés par les sous-composants du calculateur.
// dg = data_get (chemin pointé), même contrat que window.data_get utilisé par le composant racine.
export default {
    methods: {
        dg(obj, path, def = undefined) {
            if (obj === null || obj === undefined) return def;
            const out = String(path).split('.').reduce((acc, k) => (acc !== null && acc !== undefined ? acc[k] : undefined), obj);
            return out === undefined || out === null ? def : out;
        },
        isDef(v) {
            return v !== undefined && v !== null && v !== '' && !(typeof v === 'number' && isNaN(v));
        },
        round(v, decimals = 0) {
            const n = parseFloat(v);
            if (isNaN(n)) return 0;
            const f = Math.pow(10, decimals);
            return Math.round(n * f) / f;
        },
        fmt(v, decimals = 0) {
            const n = this.round(v, decimals);
            return n.toLocaleString('fr-FR', {minimumFractionDigits: decimals, maximumFractionDigits: decimals});
        },
        // Picto Green-score (feuille portant la lettre), fichiers /images/pictos/green-score-{a-plus|a..f}.png
        gsPicto(letter) {
            return '/images/pictos/green-score-' + String(letter || 'e').toLowerCase().replace('+', '-plus') + '.png';
        },
    },
};
